import Vue from 'vue'
import Router from 'vue-router'
import InventoryDashboard from '@/views/InventoryDashboard.vue'
import DeviceList from '@/views/DeviceList.vue'
import DeviceDetail from '@/views/DeviceDetail.vue'
import CompanyList from '@/views/CompanyList.vue'
import CompanyDetail from '@/views/CompanyDetail.vue'
import BatchList from '@/views/BatchList.vue'
import BatchDetail from '@/views/BatchDetail.vue'
import Scan from '@/views/Scan.vue'
import ImportPage from '@/views/Import.vue'
import Settings from '@/views/Settings.vue'
import Login from '@/views/Login.vue'
import LayoutAuth from '@/components/LayoutAuth.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/auth/login', name: 'login', components: { default: Login, layout: LayoutAuth }, meta: { layout: 'LayoutAuth' } },
    { path: '/', name: 'dashboard', component: InventoryDashboard },
    { path: '/devices', name: 'deviceList', component: DeviceList },
    { path: '/devices/:mac', name: 'deviceDetail', component: DeviceDetail, props: true },
    { path: '/companies', name: 'companyList', component: CompanyList },
    { path: '/companies/:name', name: 'companyDetail', component: CompanyDetail, props: true },
    { path: '/batches', name: 'batchList', component: BatchList },
    { path: '/batches/:number', name: 'batchDetail', component: BatchDetail, props: true },
    { path: '/scan', name: 'scan', component: Scan },
    { path: '/import', name: 'import', component: ImportPage },
    { path: '/settings', name: 'settings', component: Settings }
  ]
})

// Navigation guard (must be after router definition)
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('id_token')
  if (to.name === 'login' && token) {
    // already logged in → redirect to dashboard
    next({ name: 'dashboard' })
  } else if (to.name !== 'login' && !token) {
    // not logged in → redirect to login
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router